<template>
  <div class="flex h-full items-center justify-center space-x-2 text-center">
    <span class="sr-only">Loading...</span>
    <div class="h-6 w-6 animate-bounce rounded-full bg-primary [animation-delay:-0.3s]"></div>
    <div class="h-6 w-6 animate-bounce rounded-full bg-primary [animation-delay:-0.15s]"></div>
    <div class="h-6 w-6 animate-bounce rounded-full bg-primary"></div>
  </div>
</template>
